export default __webpack_public_path__ + "static/media/rs_school_1.1cc27900.svg";